import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Raven from 'raven-js';
import { useSegment, useMutateSegment } from 'crm-index-visualization-core';
import { useSelectedObjectTypeId } from '../../../objectTypeIdContext/hooks/useSelectedObjectTypeId';
import { ALL_PIPELINES_VALUE } from '../constants/AllPipelinesValue';
import { pipelineChanged } from '../slice/currentPipelineIdSlice';
import { clearDefaultPipelineIdInLocalStorage, setDefaultPipelineIdInLocalStorage } from '../utils/pipelineIdLocalStorage';
import { useViewActions } from '../../../views/hooks/useViewActions';
export const useCurrentPipelineIdActions = () => {
  const objectTypeId = useSelectedObjectTypeId();
  const dispatch = useDispatch();
  const {
    onViewPipelineChanged
  } = useViewActions();
  const {
    data: segment
  } = useSegment({
    onError: error => {
      Raven.captureException(error);
    }
  });
  const [mutateSegment] = useMutateSegment();
  const changePipeline = useCallback(pipelineId => {
    dispatch(pipelineChanged({
      objectTypeId,
      pipelineId
    }));
    if (pipelineId === ALL_PIPELINES_VALUE) {
      clearDefaultPipelineIdInLocalStorage(objectTypeId);
    } else {
      setDefaultPipelineIdInLocalStorage(objectTypeId, pipelineId);
    }
    if (!segment) {
      return;
    }
    const segmentWithUpdatedPipeline = segment.with({
      pipelineId: pipelineId === ALL_PIPELINES_VALUE ? null : pipelineId
    });
    mutateSegment(segmentWithUpdatedPipeline).then(() => {
      if (pipelineId === ALL_PIPELINES_VALUE) {
        onViewPipelineChanged({
          pipelineId: undefined,
          skipSync: true
        });
      } else {
        onViewPipelineChanged({
          pipelineId,
          skipSync: true
        });
      }
    }).catch(error => {
      Raven.captureException(error);
    });
  }, [segment, mutateSegment, objectTypeId, onViewPipelineChanged, dispatch]);
  return {
    changePipeline
  };
};